(() => {
  const discoverUrl = '/blogs/stories?view=discover';

  const updateDiscoverLinks = (scope = document) => {
    scope.querySelectorAll('header a[href]').forEach((link) => {
      const label = link.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (label === 'discover') link.href = discoverUrl;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateDiscoverLinks());
  } else {
    updateDiscoverLinks();
  }
  document.addEventListener('shopify:section:load', (event) => updateDiscoverLinks(event.target));
})();
